import ServiceLevels from ".";

export const serviceLevelRoutes = [
  {
    path: "/serviceLevels",
    element: <ServiceLevels />,
  },
];
